<template>
  <div class="circle-button">
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'btn',
    },
  },
};
</script>

<style scoped>
  p {
    font-size: 12px;
    margin-top: 27px;
    font-weight: bold;
  }

  .circle-button {
    background: #ffffff;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    display: flex;
    align-content: center;
    justify-content: center;
  }
</style>
